module.exports = __webpack_public_path__ + "img/dot-shape-2.6812e5e.svg";